import React from 'react';
import { papelDoItem } from '../utils/itensPorLocal';
import { TONE_BADGE } from '../utils/statusColors';
import { RateioDoGrupo, seloDoItem, fmtPercentual } from '../utils/rateioDoGrupo';

/**
 * Selo do papel do item na assinatura: rateado, próprio ou desconto.
 *
 * Um componente só para a EDIÇÃO e para a FICHA (o olho), para as duas
 * contarem a mesma história. Só aparece quando o grupo tem rateio. O
 * "68,89% de 449,00" vem da API (`seloDoItem`), nunca recalculado.
 */
interface Props {
  rateio: RateioDoGrupo | null;
  clientId: number;
  item: any;
  fmt: (v: number) => string;
}

const SeloDoPapel: React.FC<Props> = ({ rateio, clientId, item, fmt }) => {
  if (!rateio || rateio.temRateio === false || !item?.productId) return null;
  const rateados = new Set<number>(rateio.produtoIds || []);
  const papel = papelDoItem(item, rateados);
  const selo = seloDoItem(rateio, clientId, item.productId);
  const fatia = selo ? `${fmtPercentual(selo.percentual)} de ${fmt(selo.valorCheio)}` : null;
  // Cores do mapa (§4/§12.3): rateado = group, próprio = neutral, desconto = danger
  // (vermelho: desconto não é receita). Tamanho da escala, sem pixel (§11.5).
  const base = 'shrink-0 whitespace-nowrap px-1.5 py-0.5 rounded text-xs font-medium';
  if (papel === 'desconto') return <span className={`${base} ${TONE_BADGE.danger}`} title={fatia ? `Desconto rateado no grupo: ${fatia}` : 'Desconto'}>desconto{fatia ? ` · ${fatia}` : ''}</span>;
  if (papel === 'rateado') return <span className={`${base} ${TONE_BADGE.group}`} title='A fatia desta empresa no que o grupo compartilha'>{fatia || 'rateado'}</span>;
  return <span className={`${base} ${TONE_BADGE.neutral}`} title='Consumo da própria empresa'>próprio</span>;
};

export default SeloDoPapel;
